import constants from '@/config/constants';

export let getReactNativeDeviceInfoLibrary: () => Promise<{
  isPinOrFingerprintSet: () => boolean;
}>;

if (!constants.isRunningInExpoGo) {
  getReactNativeDeviceInfoLibrary = () =>
    import('react-native-device-info').then((module) => module) as any;
} else {
  getReactNativeDeviceInfoLibrary = () =>
    new Promise((resolve, _) => {
      setTimeout(() => {
        resolve({
          isPinOrFingerprintSet: () => true,
        });
      }, 300);
    });
}
